import * as React from "react";
import { Grid } from "semantic-ui-react";

import { PlayerAccount } from "@/interfaces";
import { Media } from "@/services/bedrock";
import { MediaPlayer } from "@/components/MediaPlayer";
import { PlayerInfoSection } from "@/components/PlayerInfoSection";

import "./styles.scss";

interface Props {
  videos: Media[];
  playerInfo: PlayerAccount;
}

export const PostVideoSection: React.FC<Props> = ({ videos, playerInfo }) => {
  return (
    <div className={"attachVideosSection"}>
      <PlayerInfoSection playerInfo={playerInfo} />
      <Grid>
        {videos.map((media, index) => (
          <Grid.Column key={`media_detail_container_${index}`} className={"videosContainer edited"}>
            <MediaPlayer media={media} />
          </Grid.Column>
        ))}
      </Grid>
    </div>
  );
};
